import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#071b33",
    },
    secondary: {
      main: "#c92520",
    },
    error: { main: "#c92520" },
    background: { default: "#f5f6f8", paper: "#ffffff" },
  },
  typography: {
    fontFamily: "'Roboto', 'Arial', sans-serif",
  },
});

export default theme;
